import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Lê/grava o submenu de config via ?s= (reage à navegação da busca do hub).
 * @param {string} fallback
 * @param {string[]} allowed
 * @returns {[string, (next: string) => void]}
 */
export default function useConfigSectionParam(fallback, allowed) {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('s');
  const rawOk = Boolean(raw) && (!allowed?.length || allowed.includes(raw));
  const value = rawOk ? raw : fallback;

  useEffect(() => {
    if (raw === value) return;
    setSearchParams(
      (prev) => {
        const p = new URLSearchParams(prev);
        if (p.get('s') === value) return prev;
        p.set('s', value);
        return p;
      },
      { replace: true }
    );
  }, [raw, value, setSearchParams]);

  const setValue = useCallback(
    (next) => {
      const id = String(next || '');
      if (allowed?.length && !allowed.includes(id)) return;
      setSearchParams(
        (prev) => {
          const p = new URLSearchParams(prev);
          p.set('s', id);
          return p;
        },
        { replace: true }
      );
    },
    [allowed, setSearchParams]
  );

  return [value, setValue];
}
